import React from 'react';

const Contact = () => {
  return (
    <div className="bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow p-8">
          <h1 className="text-4xl font-bold mb-6">Contact Us</h1>

          <p className="text-gray-600 text-lg mb-8">
            Have a question or need help? We'd love to hear from you.
          </p>

          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <h2 className="text-2xl font-bold mb-4">Get in Touch</h2>

              <div className="space-y-4">
                <div>
                  <h3 className="font-semibold text-gray-800">General Enquiries</h3>
                  <a
                    href="mailto:admin@contractguard.com.au"
                    className="text-primary-600 hover:text-primary-700"
                  >
                    admin@contractguard.com.au
                  </a>
                </div>

                <div>
                  <h3 className="font-semibold text-gray-800">Sales & Enterprise</h3>
                  <a
                    href="mailto:admin@contractguard.com.au"
                    className="text-primary-600 hover:text-primary-700"
                  >
                    admin@contractguard.com.au
                  </a>
                </div>
              </div>

              <div className="mt-8">
                <h2 className="text-2xl font-bold mb-4">Response Time</h2>
                <p className="text-gray-600">
                  We typically respond to all enquiries within 1-2 business days.
                </p>
              </div>
            </div>

            <div className="bg-gray-50 rounded-lg p-6">
              <h2 className="text-xl font-bold mb-4">Frequently Asked Questions</h2>
              <div className="space-y-4">
                <div>
                  <h3 className="font-semibold text-gray-800 text-sm">Is ContractGuard a law firm?</h3>
                  <p className="text-gray-600 text-sm mt-1">
                    No. ContractGuard is an AI-powered analysis tool, not a law firm. We do not provide legal advice.
                  </p>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-800 text-sm">What file types are supported?</h3>
                  <p className="text-gray-600 text-sm mt-1">
                    We support PDF and Word (.docx) documents.
                  </p>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-800 text-sm">How do I cancel my subscription?</h3>
                  <p className="text-gray-600 text-sm mt-1">
                    You can cancel anytime from your Account page. Your access continues until the end of the billing period.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
